import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getHostAccountPromo = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/productivity-host/store/list` });

  return data;
};

export default getHostAccountPromo;
